import * as React from "react";
import { Util } from "@grandvisionhq/common";
import { useIntl } from "@grandvisionhq/state";
import { Title } from "../../../../components/modules/MiniCart/components/Title.js";
import { useCart } from "../../../../../../context/Cart/context/Cart/context.js";
const TitleContainer = () => {
  const intl = useIntl();
  const { cart } = useCart();
  const numberOfItems = cart ? cart.numberOfItems : 0;
  const value = React.useMemo(() => {
    return Util.getCartTotalsTitle(
      numberOfItems,
      intl,
      "cart.minicart.totalsTitle.singular",
      "cart.minicart.totalsTitle"
    );
  }, [numberOfItems, intl]);
  return /* @__PURE__ */ React.createElement(Title, { value });
};
export {
  TitleContainer
};
//# sourceMappingURL=TitleContainer.js.map
